const BreadCrumbMapper: Record<string, string> = {
}

export default BreadCrumbMapper
